import { useMemo } from 'react'
import { type GetHookResponse } from '../hooks'
import { eventOutcomesKey } from '../keys'
import { useTantalimQuery } from '../query'
import {
  HOUR,
  DAY,
  type ArchivedFilter,
  type EventOutcomeListInput,
  type EventOutcomeListSuccess,
  type EventOutcomeId,
  type EventOutcomeData,
  isEmpty,
} from '@terros/common'

type Success = EventOutcomeListSuccess

export function useEventOutcomes(archived?: ArchivedFilter): GetHookResponse<Success> {
  return useTantalimQuery<EventOutcomeListInput, Success, Success>({
    url: '/calendar/outcome/list',
    queryKey: eventOutcomesKey(),
    input: { archived },
    convertResponse: (d) => d,
    options: {
      staleTime: 12 * HOUR,
      gcTime: DAY,
    },
  })
}

export const useEventOutcomesMap = (): Map<EventOutcomeId, EventOutcomeData> => {
  const { data } = useEventOutcomes()
  return useMemo(() => toEventOutcomesMap(data?.outcomes), [data])
}

const toEventOutcomesMap = (outcomes: EventOutcomeData[] | undefined): Map<EventOutcomeId, EventOutcomeData> => {
  const map = new Map<EventOutcomeId, EventOutcomeData>()
  if (isEmpty(outcomes)) return map
  outcomes.forEach((outcome) => {
    map.set(outcome.outcomeId, outcome)
  })
  return map
}
